/**
 * WhatsApp only treats these delimiters as formatting when they are isolated,
 * contain non-whitespace text and do not touch whitespace on the inside.
 *
 * Keep factories instead of shared RegExp instances because the global
 * expressions are stateful (`lastIndex`).
 */
export function createWhatsappBoldRegex() {
  return /(?<!\*)\*([^*\s](?:[^*]*[^*\s])?)\*(?!\*)/g;
}

export function createWhatsappBoldInputRegex() {
  return /(?<!\*)\*([^*\s](?:[^*]*[^*\s])?)\*(?!\*)$/;
}

export function createWhatsappItalicRegex() {
  return /(?<!_)_([^_\s](?:[^_]*[^_\s])?)_(?!_)/g;
}

export function createWhatsappItalicInputRegex() {
  return /(?<!_)_([^_\s](?:[^_]*[^_\s])?)_(?!_)$/;
}

export function createWhatsappStrikeRegex() {
  return /(?<!~)~([^~\s](?:[^~]*[^~\s])?)~(?!~)/g;
}

export function createWhatsappStrikeInputRegex() {
  return /(?<!~)~([^~\s](?:[^~]*[^~\s])?)~(?!~)$/;
}
